export interface ShareFileOptions {
  url: string;
  fileName: string;
}

export const isShareSupported = (url: string): boolean => {
  try {
    return navigator.canShare?.({ url }) ?? false;
  } catch {
    return false;
  }
};

export const shareFile = async ({
  url,
  fileName,
}: ShareFileOptions): Promise<void> => {
  try {
    const file = await prepareFile(url, fileName);
    const shareData: ShareData = {
      url,
      files: [file],
    };
    await navigator.share(shareData);
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") return;
    console.error(
      "[shareFile] Failed to share file, falling back to URL share:",
      error,
    );
    try {
      await navigator.share({ url });
    } catch (urlShareError) {
      console.error("[shareFile] Failed to share URL:", urlShareError);
      throw urlShareError;
    }
  }
};

export const prepareFile = async (fileUrl: string, fileName: string) => {
  const res = await fetch(fileUrl);
  const blob = await res.blob();
  const file = new File([blob], fileName, {
    type: blob.type,
  });
  return file;
};
